<template>
  <div class="container no-margin">
    <cuil-number-input
      label="CUIT"
      name="cuit"
      :value="value"
      @input="onInput"
      maxlength="13"
      v-mask="'##-########-#'"
      :required="required"
      subhint="Ingresá tu CUIT sin guiones"
      @focus="$emit('focus')"
    />
  </div>
</template>

<script>
import CuilNumberInput from "@/components/core/composite/combos/CuilNumberInput";
import { mask } from "vue-the-mask";
export default {
  name: "CuilInput",
  components: { CuilNumberInput },
  props: ["placeholder", "label", "value", "required"],
  directives: {
    mask
  },
  methods: {
    onInput(val) {
      this.$emit("input", val);
    }
  }
};
</script>

<style scoped></style>
